export default __webpack_public_path__ + "static/media/backers5.2eb2eeb8.png";